export default __webpack_public_path__ + "static/media/contributePickupShipping.4077e9c6.png";